'use client';

import Image, { ImageLoaderProps } from 'next/image';

const imageLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${src}?x-oss-process=image/resize,w_${width},q_${quality || 75}`;
};

export const ImageContainer = ({ src, className }: { src: string; className?: string }) => {
  return (
    <div
      className={`relative w-full h-[100vw] max-h-[480px] rounded-bl-[1.875rem] overflow-hidden ${className}`}
    >
      <Image
        loader={imageLoader}
        src={src}
        alt="Detailed Image"
        fill
        priority
        className="object-cover bg-gradient-to-b from-black to-black"
      />
    </div>
  );
};
